var common = require('./common');
var howler = require('howler');
var Howl = howler.Howl;

module.exports = function($) {

  var Game = require('./game')($);

  function BuilderGame(gameOpts) {
    Game.call(this, gameOpts);
    this.baseList.forEach(function(question) {
      question.parts = question.word.split(/ +/);
    });
    this.star = gameOpts.star;
    this.parts = gameOpts.parts.split(/ +/);
    this.allColors = gameOpts.colors;
    this.instruct = new Howl({
      src: [gameOpts.instruct]
    });
    this.chime = new Howl({
      src: [gameOpts.chime]
    });
    this.winSound = new Howl({
      src: [gameOpts.winSound]
    });
  }

  BuilderGame.prototype = Object.create(Game.prototype);

  BuilderGame.prototype.start = function() {
    // I'm not sorting out multiple closures with .bind()s.
    var parts = this.parts;
    var game = this;
    $('.keypad button')
      .hide()
      .each(function(index) {
        $(this)
          .text(parts[index])
          .show()
          .click(function() {
            game.tryLetter($(this).text());
          });
        if(!parts[index+1]) return false;
      });
    $('.star')
      .load(this.star);
    $('.soundhint')
      .click(() => {game.curQuestion.definitionSound.play();});
    $('.instruct button')
      .click(() => {game.instruct.play();});
    $('td.tile')
      .hide();
    // Why did we just mess around with Ajax? We need an *inline* SVG, which can't be created by changing
    // the src of an img tag.
    this.colors = common.shuffle(this.allColors);
    Game.prototype.start.call(this);
  };

  BuilderGame.prototype.nextQuestion = function() {
    Game.prototype.nextQuestion.call(this);
    // TODO: Allow for longer blends.
    $('td.tile').slice(0, this.curQuestion.parts.length).fadeIn().text('?');
    this.blendIndex = 0;
    if(this.curQuestion.definitionImageUrl) {
      $('#def_img').attr('src', this.curQuestion.definitionImageUrl);
    }
    if(this.curQuestion.definition) {
      $("#question").html(this.curQuestion.definition);
    }
  };

  BuilderGame.prototype.tryLetter = function(letter) {
    if(this.lock) return;
    this.lock = true;
    var game = this;
    if(letter == this.curQuestion.parts[this.blendIndex]) {
      $('td.tile').eq(this.blendIndex)
        .hide()
        .css('color', 'green')
        .text(letter)
        .fadeIn(function() {
          $(this).css('color', 'black');
          if(++game.blendIndex >= game.curQuestion.parts.length) {
            game.chime.play();
            $('td.tile').slice(0, game.curQuestion.parts.length).delay(400).fadeOut();
            $('td.tile').promise().always(() => {
              game.newStar().then(() => {game.nextQuestion()});
            });
          }
        });
    } else {
      $('td.tile').eq(this.blendIndex)
        .hide()
        .css('color', 'red')
        .text('X')
        .fadeIn(function() {
          $(this).fadeOut(() => {
            $(this).css('color', 'black').text('?').show();
          });
        });
    }
    $('td.tile').promise().always(() => {game.lock = false});
  };

  BuilderGame.prototype.newStar = function() {
    $('.starbg').css('fill', this.colors.shift());
    if(this.colors.length == 0) {
      this.colors = common.shuffle(this.allColors);
    }
    return Promise.resolve();
  };

  BuilderGame.prototype.win = function() {
    $('.container, .instruct').slideUp();
    $('.win').slideDown();
    this.winSound.play();
  };

  return BuilderGame;

};
